<template>
  <div
    class="dui-social-links"
    :class="{ 'open': vm.isOpen }"
  >
    <div
      v-if="vm.displayedLinks.length"
      v-once
      class="button-group"
    >
      <a
        v-for="(link, index) in vm.displayedLinks"
        v-once
        :key="link.name"
        :alt="link.name"
        class="button button-lg button-translucent button-image"
        :class="{ 'collapse': (index >= alwaysShow) }"
        :href="link.url"
        target="_blank"
        :title="link.name"
        rel="nofollow"
      >
        <img :src="link.icon">
      </a>

      <a
        v-for="(link, index) in vm.moreLinks"
        v-once
        :key="link.name"
        :alt="link.name"
        class="big-screen button button-lg button-translucent button-image"
        :class="{ 'collapse': (index >= alwaysShow) }"
        :href="link.url"
        target="_blank"
        :title="link.name"
        rel="nofollow"
      >
        <img :src="link.icon">
      </a>

      <a
        v-if="vm.moreLinks.length"
        v-once
        class="toggle button button-lg button-translucent"
        @click="toggleOpen"
      >
        +{{ vm.moreLinks.length }}
      </a>
    </div>

    <div
      v-if="vm.moreLinks.length"
      v-once
      class="content-container"
    >
      <div class="button-group">
        <a
          v-for="link in vm.moreLinks"
          :key="link.name"
          :alt="link.name"
          class="button button-lg button-black button-image"
          :href="link.url"
          target="_blank"
          :title="link.name"
          rel="nofollow"
        >
          <img :src="link.icon">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import contextMenuMixin from '@dui/mixins/context-menu';

import FACEBOOK_IMG from '@dui-assets/social/facebook-white.svg';
import GOODREADS_IMG from '@dui-assets/social/goodreads-white.svg';
import INSTAGRAM_IMG from '@dui-assets/social/instagram-white.svg';
import LINKEDIN_IMG from '@dui-assets/social/linkedin-white.svg';
import TWITTER_IMG from '@dui-assets/social/twitter-white.svg';
import WEBSITE_IMG from '@dui-assets/social/website-white.svg';
import YOUTUBE_IMG from '@dui-assets/social/youtube-white.svg';
import TIKTOK_IMG from '@dui-assets/social/tiktok-white.svg';

const SOCIAL_ICONS = Object.freeze({
  facebook: FACEBOOK_IMG,
  goodreads: GOODREADS_IMG,
  instagram: INSTAGRAM_IMG,
  linkedin: LINKEDIN_IMG,
  tiktok: TIKTOK_IMG,
  twitter: TWITTER_IMG,
  website: WEBSITE_IMG,
  youtube: YOUTUBE_IMG,
});

export default {
  mixins: [
    contextMenuMixin,
  ],
  props: {
    alwaysShow: {
      type: Number,
      default: 1,
    },
    links: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    vm: {
      displayedLinks: [],
      moreLinks: [],
    },
  }),
  mounted() {
    this.setupLinks();
  },
  methods: {
    setupLinks() {
      this.links.forEach((link) => {
        if (!link.url || typeof link.url !== 'string') {
          return;
        }

        if (link.url.indexOf('https://') !== 0
          && link.url.indexOf('http://') !== 0) {
          return;
        }

        const decoratedLink = {
          icon: SOCIAL_ICONS[link.name.toLowerCase()],
          name: link.name,
          url: link.url,
        };

        if (this.vm.displayedLinks.length < this.alwaysShow) {
          this.vm.displayedLinks.push(decoratedLink);
          return;
        }

        this.vm.moreLinks.push(decoratedLink);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-social-links {
  display: inline-flex;

  @include makePopoverContainer();

  .big-screen {
    display: none;
  }

  button,
  .button {
    img {
      height: $_3em;
      width: $_3em;
    }
  }

  .content-container {
    left: initial;
    right: 0;
    top: 100%;

    .button-group {
      box-shadow: $box-shadow-context-menu;
      flex-direction: column;

      .button {
        padding: 26px;
      }
    }
  }

  &.open .content-container {
    top: calc(100% + #{ $_1em });
  }

  @include screenMoreThan(sm) {
    .big-screen {
      display: block;
    }

    .content-container,
    .toggle {
      display: none;
    }
  }

}
</style>
